/**
 * Lead actions — single source of truth for "Mark as complete" / "Mark done".
 * COMPLETED is independent from LOST: no stage/outcome change, no destructive UI.
 */

import { LeadsService, type UpdateLeadInput } from '@/data/leads.service';

export interface CompleteLeadOptions {
  /** When true, mark as "Not fit / don't contact" (DONE, not LOST). */
  optOut?: boolean;
}

/**
 * Mark a lead as completed (no next step). Sets status='done', is_completed, completed_at,
 * clears follow-up fields. Does NOT set pipeline_stage, lost_reason, or any lost state.
 * Use optOut: true for "Not fit / don't contact".
 */
export async function completeLead(
  leadId: string,
  workspaceId: string,
  options?: CompleteLeadOptions
): Promise<void> {
  const now = new Date().toISOString();

  await LeadsService.updateLead({
    id: leadId,
    workspace_id: workspaceId,
    status: 'done',
    is_completed: true,
    completed_at: now,
    last_interaction_at: now,
    last_contacted_at: now,
    next_follow_up_at: null,
    next_action_at: null,
    next_action_type: null,
    ...(options?.optOut === true ? { opt_out: true } : {}),
  } as UpdateLeadInput);
}
